import CovidCasesMain from './CovidCasesMain';

export default CovidCasesMain;
